import { useRef } from "react";
import { trackAnalyticsEvent } from "../utils/analytics";
import { stripExtension } from "../utils/videoResolver";

// En visning per klipp i den öppna spelaren, även vid paus och buffring.
export default function TrackedVideo({ clipPath, clipTitle, sessionId, children, ...props }) {
  const trackedPaths = useRef(new Set());
  const path = clipPath ? `/${stripExtension(clipPath.trim()).replace(/^\/+/, "")}` : "";

  function handlePlaying() {
    if (!path || trackedPaths.current.has(path)) return;
    trackedPaths.current.add(path);
    trackAnalyticsEvent("/analytics/track-video-view", {
      clipPath: path,
      clipTitle,
      ...(sessionId ? { sessionId } : {})
    });
  }

  return <video {...props} onPlaying={handlePlaying}>{children}</video>;
}
